import { create } from 'zustand';

type MassSelectionState = {
  sapCodes: string[];
};

type MassSelectionActions = {
  updateCodes: (sapCodes: string) => void;
  resetCodes: () => void;
};

export const useMassSelection = create<
  MassSelectionState & MassSelectionActions
>(set => {
  const updateCodes = (sapCodes: string) => {
    const codesArray = sapCodes.split(';').filter(code => code.trim() !== '');
    const uniqueCodes = Array.from(new Set(codesArray));
    set({ sapCodes: uniqueCodes });
  };

  return {
    sapCodes: [],
    updateCodes,
    resetCodes: () => {
      set({ sapCodes: [] });
    },
  };
});
